export function padMemberNoSeq(n: number, digits: number): string {
  const d = Number.isFinite(digits) ? Math.max(2, Math.min(10, digits)) : 4;
  const s = String(Math.max(1, Math.floor(n || 1)));
  return s.padStart(d, "0");
}

/** 按租户编号规则拼完整会员编号；前缀留空则跳过该段，全空时仅序号。 */
export function composeMemberNoFromRule(
  rule: { tenantPrefix: string; separator: string; digits: number; levelPrefixes: Record<string, string> },
  levelName: string,
  sequenceTail: string,
): string {
  const tp = (rule.tenantPrefix || "").trim();
  const sep = (rule.separator || "").trim();
  const name = (levelName || "").trim() || "普通会员";
  const lp = String((rule.levelPrefixes || {})[name] ?? "").trim();
  const digits = rule.digits ?? 4;
  const tail = String(sequenceTail || "")
    .replace(/\D/g, "")
    .slice(-digits)
    .padStart(digits, "0");
  const parts: string[] = [];
  if (tp) parts.push(tp);
  if (lp) parts.push(lp);
  parts.push(tail);
  return sep ? parts.join(sep) : parts.join("");
}
